import * as React from "react";
import BorderedBox from "../SharedComponents/BorderedBox";
import { Competition } from "../../types/competition";
import { HandicapAdjustmentMode, HandicapSourceType } from "../../types/game";
import HandicapSourceFields from "./HandicapSourceFields";

export interface GameHandicapSourceSectionProps {
  handicapSourceType?: HandicapSourceType;
  handicapSourceCompetitionId?: string;
  handicapAdjustmentMode?: HandicapAdjustmentMode;
  competitions: Competition[];
  ruleId?: string;
  allowExternalCustomListings?: boolean;
  onHandicapListingChange: (sourceType: HandicapSourceType, sourceCompetitionId?: string) => void;
  onApplyRulesToggle: (value: HandicapAdjustmentMode) => void;
  errListing?: boolean;
  errAdjustment?: boolean;
}

const GameHandicapSourceSection: React.FunctionComponent<GameHandicapSourceSectionProps> = props => {
  const hasError = !!(props.errListing || props.errAdjustment);

  return (
    <BorderedBox title={"Handicap source"} variant={"h6"} error={hasError}>
      <HandicapSourceFields
        {...props}
        listingHint="Which handicaps this game uses."
        savePrompt="Pick one option."
      />
    </BorderedBox>
  );
};

export default GameHandicapSourceSection;
